import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#1F3B35",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M20.4 19.701a1.428 1.428 0 0 1-1.429 1.586H5.03A1.427 1.427 0 0 1 3.6 19.7L4.857 8.43h14.286zM8.429 8.43V6.285a3.571 3.571 0 1 1 7.142 0V8.43"
    }, null, -1)
  ])))
}
export default { render: render }